export function calculateReadingTime(content: string, wordsPerMinute = 200): number {
  if (!content) return 0;
  const text = content.trim().replace(/\s+/g, ' ');
  const wordCount = text.split(' ').length;
  return Math.max(1, Math.ceil(wordCount / wordsPerMinute));
}
